import React, { useRef, useState, useEffect } from 'react';
import { useTheme } from '../../styles/ThemeProvider';

export const ExportButton = ({ onExportCsv, onExportXlsx, onExportPdf, disabled }) => {
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const option = (label, fn) => fn && (
    <button
      onClick={() => { fn(); setOpen(false); }}
      style={{
        display: 'block', width: '100%', textAlign: 'left',
        padding: `${theme.space.sm}px ${theme.space.md}px`,
        background: 'transparent', border: 'none', cursor: 'pointer',
        fontSize: theme.font.size.sm, color: theme.color.text,
        fontFamily: theme.font.family,
      }}
      onMouseEnter={(e) => e.currentTarget.style.background = theme.color.surfaceAlt}
      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}>
      {label}
    </button>
  );

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        disabled={disabled}
        onClick={() => setOpen(!open)}
        style={{
          padding: `${theme.space.xs}px ${theme.space.md}px`,
          borderRadius: theme.radius.sm,
          border: `1px solid ${theme.color.border}`,
          background: theme.color.surface,
          color: disabled ? theme.color.muted : theme.color.text,
          fontSize: theme.font.size.xs,
          fontWeight: theme.font.weight.medium,
          cursor: disabled ? 'not-allowed' : 'pointer',
          fontFamily: theme.font.family,
          display: 'inline-flex',
          gap: 4,
          alignItems: 'center',
        }}>
        ↓ Dışa Aktar
      </button>
      {open && (
        <div style={{
          position: 'absolute', right: 0, top: 'calc(100% + 4px)',
          background: theme.color.surface,
          border: `1px solid ${theme.color.border}`,
          borderRadius: theme.radius.sm,
          boxShadow: theme.shadow.md,
          minWidth: 160,
          zIndex: 10,
          overflow: 'hidden',
        }}>
          {option('CSV', onExportCsv)}
          {option('Excel (.xlsx)', onExportXlsx)}
          {option('PDF', onExportPdf)}
        </div>
      )}
    </div>
  );
};
